export default __webpack_public_path__ + "static/media/users-01.a6375454.png";